import { useEffect, useState } from "react";
import styles from "./styles.module.css";

export default function ElementActions({ actions, onSelect }) {
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    const blocks = [];
    actions.forEach((a) => {
      if (!blocks.includes(a.block)) blocks.push(a.block);
    });
    setBlocks(blocks);
  }, [actions]);

  const handleSelect = (a) => {
    const _a = { ...a };
    onSelect(_a);
  };
  return (
    <div className={styles.elementActions}>
      {blocks.map((b) => {
        return (
          <div key={b}>
            <div className={styles.eaTitle}>{b}</div>
            <div className={styles.eaRow}>
              {actions
                .filter((x) => x.block === b)
                .map((a) => {
                  return (
                    <div
                      onClick={() => handleSelect(a)}
                      className={styles.actionItem}
                      key={a.code}
                    >
                      {a.displayName}
                    </div>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
